var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-dialog",
    {
      staticClass: "add-user-dialog",
      attrs: { "md-active": _vm.show, id: `view-uid-${_vm.viewId}` },
      on: {
        "update:mdActive": function ($event) {
          _vm.show = $event
        },
        "update:md-active": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _vm.title
        ? _c("md-dialog-title", [
            _vm._v(
              _vm._s(_vm.t("app-add-new-administrator", { title: _vm.title }))
            ),
          ])
        : _c("md-dialog-title", [
            _vm._v(_vm._s(_vm.t("app-add-new-administrator-no-title"))),
          ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "standard-form-style",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.save()
            },
          },
        },
        [
          _c("div", { staticClass: "ui-form-row" }, [
            _c("div", { staticClass: "description description-small" }, [
              _vm._v(_vm._s(_vm.t("app-email-reference-tip"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-loading" },
            [
              _c("app-input", {
                attrs: {
                  type: "text",
                  required: "true",
                  label: _vm.t("app-email"),
                },
                model: {
                  value: _vm.mail,
                  callback: function ($$v) {
                    _vm.mail = $$v
                  },
                  expression: "mail",
                },
              }),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "loading",
                  staticStyle: { "enable-background": "new 0 0 20 20" },
                  attrs: {
                    "data-loading": _vm.loading,
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10,20C4.49,20,0,15.51,0,10S4.49,0,10,0s10,4.49,10,10c0,2.67-1.04,5.18-2.93,7.07l-1.42-1.41C17.17,14.15,18,12.14,18,10c0-4.41-3.59-8-8-8s-8,3.59-8,8s3.59,8,8,8V20z",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "user-list" },
            [
              _vm._l(_vm.accounts.list, function (account) {
                return _c("li", { key: account.id }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save(account.mail, account)
                        },
                      },
                    },
                    [
                      account.firstName
                        ? _c("div", { staticClass: "user-name" }, [
                            _vm._v(
                              _vm._s(account.firstName) +
                                " " +
                                _vm._s(account.lastName)
                            ),
                          ])
                        : _c("div", { staticClass: "user-name" }, [
                            _vm._v(
                              _vm._s(_vm.t("app-add-user-invitation-pending"))
                            ),
                          ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-email" }, [
                        _vm._v(_vm._s(account.mail)),
                      ]),
                    ]
                  ),
                ])
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.newUser,
                      expression: "newUser",
                    },
                  ],
                },
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save(_vm.mail)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "user-name" }, [
                        _c("span", { staticClass: "user-new-tip" }, [
                          _vm._v(_vm._s(_vm.t("app-add-user-add"))),
                        ]),
                        _vm._v(" " + _vm._s(_vm.mail) + " "),
                        _c("span", { staticClass: "user-new-tip" }, [
                          _vm._v(
                            _vm._s(_vm.t("app-add-user-as-an-administrator"))
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.noResults,
                      expression: "noResults",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "user-no-results" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.t("app-add-user-no-matches"))),
                    ]),
                  ]),
                ]
              ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "compact neutral",
            on: {
              click: function ($event) {
                _vm.show = false
              },
            },
          },
          [_vm._v(_vm._s(_vm.t("app-cancel")))]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }